(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurea-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aurea-countdown')) {
    class AureaCountdown extends HTMLElement {
      connectedCallback() {
        const total = Math.max(1, parseFloat(this.dataset.hours || '2')) * 3600000;
        const key = this.dataset.key;
        const read = () => { try { return parseInt(localStorage.getItem(key), 10); } catch (e) { return NaN; } };
        const write = (v) => { try { localStorage.setItem(key, String(v)); } catch (e) {} };
        let end = read();
        if (!end || end < Date.now()) { end = Date.now() + total; write(end); }
        const pad = (n) => String(n).padStart(2, '0');
        const tick = () => {
          let left = end - Date.now();
          if (left <= 0) { end = Date.now() + total; write(end); left = total; }
          const s = Math.floor(left / 1000);
          this.querySelector('[data-h]').textContent = pad(Math.floor(s / 3600));
          this.querySelector('[data-m]').textContent = pad(Math.floor((s % 3600) / 60));
          this.querySelector('[data-s]').textContent = pad(s % 60);
        };
        tick();
        this.timer = setInterval(tick, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    }
    customElements.define('aurea-countdown', AureaCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurea-home-featured"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aurea-home-gallery')) {
    customElements.define('aurea-home-gallery', class extends HTMLElement {
      connectedCallback() {
        const slides = this.querySelectorAll('.au-h-feat__slide');
        const thumbs = this.querySelectorAll('.au-h-feat__thumb');
        thumbs.forEach((t, i) => t.addEventListener('click', () => {
          if (!slides[i]) return;
          slides.forEach((s, j) => { s.hidden = j !== i; });
          thumbs.forEach((x, j) => x.classList.toggle('is-active', j === i));
        }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurea-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aurea-timeline')) {
    class AureaTimeline extends HTMLElement {
      connectedCallback() {
        this.steps = [...this.querySelectorAll('.au-tl__step')];
        this.fill = this.querySelector('.au-tl__fill');
        this.list = this.querySelector('.au-tl__steps');
        this.onScroll = () => this.update();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.update();
      }
      disconnectedCallback() { window.removeEventListener('scroll', this.onScroll); }
      update() {
        const vh = window.innerHeight;
        const line = vh * 0.6;
        const r = this.list.getBoundingClientRect();
        let progress = (line - r.top) / r.height;
        progress = Math.max(0, Math.min(1, progress));
        this.fill.style.height = progress * 100 + '%';
        this.steps.forEach((s) => s.classList.toggle('is-active', s.getBoundingClientRect().top < line));
      }
    }
    customElements.define('aurea-timeline', AureaTimeline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
